import React, { useEffect, useState } from "react";
import "./Money_Action_Modal.css";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import classNames from "classnames";
import Modal_Heading from "../../Modal_Heading/Modal_Heading";

const MIN_AMOUNT = 1;
const MAX_AMOUNT = 10000000; // ₹1,00,00,000 per transaction

const formatINR = (value) =>
  `₹${Number(value || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

// Returns an error message, or "" when the amount is valid
export const validateMoneyAmount = (amount, moneyAction, balance) => {
  const value = String(amount ?? "").trim();

  if (!value) return "Amount is required";
  if (!/^\d+$/.test(value)) return "Enter a valid whole number amount";

  const number = Number(value);
  if (number < MIN_AMOUNT) return `Minimum amount is ${formatINR(MIN_AMOUNT)}`;
  if (number > MAX_AMOUNT) return `Maximum amount is ${formatINR(MAX_AMOUNT)}`;

  if (moneyAction === "Debit" && balance !== undefined && balance !== null) {
    const available = Number(balance) || 0;
    if (available <= 0) return "Wallet balance is ₹0, nothing to deduct";
    if (number > available)
      return `Amount cannot exceed wallet balance of ${formatINR(available)}`;
  }

  return "";
};

function Money_Action_Modal({
  show,
  onHide,
  moneyAction,
  amount,
  setAmount,
  balance,
  loading,
  onSubmit,
}) {
  const isCredit = moneyAction === "Credit";
  const [touched, setTouched] = useState(false);

  // Fresh validation state every time the modal opens
  useEffect(() => {
    if (show) setTouched(false);
  }, [show]);

  const error = validateMoneyAmount(amount, moneyAction, balance);
  const showError = touched && !!error;

  const handleChange = (e) => {
    // digits only, no leading zeros
    const digits = e.target.value.replace(/\D/g, "").replace(/^0+/, "");
    setAmount(digits.slice(0, String(MAX_AMOUNT).length));
    setTouched(true);
  };

  const handleSubmit = () => {
    setTouched(true);
    if (error || loading) return;
    onSubmit();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      className="Edit_User_Modal modal_holder Money_Action_Modal"
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal_Heading
        modalHeading={isCredit ? "Add Money (Credit)" : "Deduct Money (Debit)"}
      />
      <div className="modal-body-holder">
        <Modal.Body>
          <div className="main-form-holder">
            <Form
              className="form-holder"
              noValidate
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}>
              {balance !== undefined && balance !== null && (
                <div className="wallet-balance">
                  Wallet Balance <span>{formatINR(balance)}</span>
                </div>
              )}

              <Form.Group className="form-field">
                <Form.Label>Enter Amount (₹)*</Form.Label>
                <InputGroup hasValidation>
                  <InputGroup.Text>₹</InputGroup.Text>
                  <Form.Control
                    type="text"
                    inputMode="numeric"
                    autoComplete="off"
                    placeholder="Enter amount"
                    value={amount}
                    onChange={handleChange}
                    onBlur={() => setTouched(true)}
                    className={classNames({ "is-invalid": showError })}
                    autoFocus
                  />
                </InputGroup>
                {showError ? (
                  <span className="text-danger">{error}</span>
                ) : (
                  <span className="amount-hint">
                    Min {formatINR(MIN_AMOUNT)} · Max{" "}
                    {formatINR(
                      !isCredit && balance !== undefined && balance !== null
                        ? Math.min(Number(balance) || 0, MAX_AMOUNT)
                        : MAX_AMOUNT,
                    )}
                  </span>
                )}
              </Form.Group>
            </Form>

            <div className="modal-footer-holder">
              <div className="d-flex justify-content-center align-items-center">
                <Button className="search-btn mx-2" onClick={onHide}>
                  Cancel
                </Button>
                <Button
                  className="reset-btn mx-2"
                  type="button"
                  onClick={handleSubmit}
                  disabled={loading || showError}>
                  {loading
                    ? "Processing..."
                    : isCredit
                      ? "Add Money"
                      : "Deduct Money"}
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </div>
    </Modal>
  );
}

export default Money_Action_Modal;
